const baseUrl = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8080/api/v1'
const timeoutMs = Number(import.meta.env.VITE_API_TIMEOUT || 30000)

async function request(path) {
  const controller = new AbortController()
  const timeoutId = setTimeout(() => {
    controller.abort(new Error(`Request timed out after ${timeoutMs}ms. Pastikan server API aktif.`))
  }, timeoutMs)

  try {
    const response = await fetch(`${baseUrl}${path}`, {
      method: 'GET',
      headers: { Accept: 'application/json' },
      signal: controller.signal,
    })
    const contentType = response.headers.get('content-type') || ''
    const body = contentType.includes('application/json')
      ? await response.json()
      : await response.text()

    if (!response.ok) {
      const message = typeof body === 'object'
        ? body.message || body.error || 'Request gagal'
        : String(body || 'Request gagal')
      throw new Error(message)
    }

    return body
  } finally {
    clearTimeout(timeoutId)
  }
}

function buildQuery(params = {}) {
  const query = new URLSearchParams()
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      query.set(key, String(value))
    }
  })
  const encoded = query.toString()
  return encoded ? `?${encoded}` : ''
}

export const publicClient = {
  discovery: (params) => request(`/public/discovery${buildQuery(params)}`),
  catalog: (slug) => request(`/public/catalogs/${encodeURIComponent(slug)}`),
  tableSession: (token) => request(`/public/table-sessions/${encodeURIComponent(token)}`),
}
